import React from 'react';
import SettingsSaveButton from '../SettingsSaveButton';
import MotorCurrencySelect from '../MotorCurrencySelect';

const JaluziSettings = React.memo(({
  activeTypeTab,
  jaluziExtras,
  setJaluziExtras,
  metalJaluziExtras,
  setMetalJaluziExtras,
  handleSaveSettings,
  isSavingSettings
}) => {
  const isAhsap = activeTypeTab === 'ahsapJaluzi';
  const extras = isAhsap ? jaluziExtras : metalJaluziExtras;
  const setExtras = isAhsap ? setJaluziExtras : setMetalJaluziExtras;

  return (
    <>
      <div className="settings-card">
        <div className="settings-card-header">
          <div className="settings-card-title">
            <i className="fas fa-cogs"></i>
            <div className="settings-card-title-text">
              <h4>Motor Ayarları</h4>
              <span className="settings-card-subtitle">Motor döviz kuru ve ücret bilgileri</span>
            </div>
          </div>
          <SettingsSaveButton
            onClick={() => handleSaveSettings()}
            isSaving={isSavingSettings}
          />
        </div>

        <div className="settings-fields-grid settings-fields-grid--compact">
          <div className="form-group">
            <label>Motor Döviz Kuru</label>
            <MotorCurrencySelect
              value={extras.motorCurrency}
              onChange={(currency) => setExtras(p => ({ ...p, motorCurrency: currency }))}
            />
          </div>
          <div className="form-group">
            <label>Motor Ücreti</label>
            <div className="settings-input-wrap">
              <input
                type="number"
                value={extras.motorPrice}
                onChange={(e) => setExtras(p => ({ ...p, motorPrice: e.target.value }))}
                placeholder="0"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <div className="settings-card-title">
            <i className={isAhsap ? 'fas fa-sliders-h' : 'fas fa-layer-group'}></i>
            <div className="settings-card-title-text">
              <h4>{isAhsap ? 'Ahşap' : 'Metal'} Jaluzi Ek Ücretler</h4>
              <span className="settings-card-subtitle">Ek hizmet ve sistem ücretleri</span>
            </div>
          </div>
          <SettingsSaveButton
            onClick={() => handleSaveSettings()}
            isSaving={isSavingSettings}
          />
        </div>

        <div className="settings-fields-grid">
          <div className="form-group">
            <label>{isAhsap ? 'Zıgıl Sistem' : 'Zıgıl Sistem (Adet)'}</label>
            <div className="settings-input-wrap">
              <input
                type="number"
                value={extras.zigil}
                onChange={(e) => setExtras(p => ({ ...p, zigil: e.target.value }))}
                placeholder="0"
              />
              <span className="settings-input-suffix">₺</span>
            </div>
          </div>

          {!isAhsap && (
            <>
              <div className="form-group">
                <label>Redüktörlü Farkı (m²)</label>
                <div className="settings-input-wrap">
                  <input
                    type="number"
                    value={extras.reduktor}
                    onChange={(e) => setExtras(p => ({ ...p, reduktor: e.target.value }))}
                    placeholder="0"
                  />
                  <span className="settings-input-suffix">₺</span>
                </div>
              </div>
              <div className="form-group">
                <label>İki Cam Arası (Adet)</label>
                <div className="settings-input-wrap">
                  <input
                    type="number"
                    value={extras.ikiCamArasi}
                    onChange={(e) => setExtras(p => ({ ...p, ikiCamArasi: e.target.value }))}
                    placeholder="0"
                  />
                  <span className="settings-input-suffix">₺</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
});

export default JaluziSettings;
